import { render } from "./Streamers.vue?vue&type=template&id=16250530"
import script from "./Streamers.vue?vue&type=script&lang=ts"
export * from "./Streamers.vue?vue&type=script&lang=ts"

import "./Streamers.vue?vue&type=style&index=0&id=16250530&lang=scss"
script.render = render

export default script